import { Term } from 'services/terms-and-conditions/types'

import { interWbHttp } from '@interco/inter-webview-bridge'

import { W8_DOCUMENT_ENDPOINT, W8_TERM_ID, W8_TERM_TITLE } from './constants'
import { W8Document, W8DocumentApiResponse } from './types'
import { isW8DocumentUnavailable } from './utils'

export const getW8Document = async (): Promise<W8Document | null> => {
  try {
    const { response } = await interWbHttp.get({
      endpoint: W8_DOCUMENT_ENDPOINT,
      org: 'US_BRANCH',
    })

    const parsed = JSON.parse(response) as W8DocumentApiResponse

    return { documentUrl: parsed.documentUrl }
  } catch (error) {
    if (isW8DocumentUnavailable(error)) {
      return null
    }

    throw error
  }
}

export const toW8Term = (document: W8Document): Term => ({
  key: W8_TERM_ID,
  id: W8_TERM_ID,
  title: W8_TERM_TITLE,
  description: '',
  url: document.documentUrl,
})
